import { Injectable } from '@angular/core';
import { IFreightDetailedForShipper, UUID } from '@okcargo-apps/shared-domain';

@Injectable({
  providedIn: 'root',
})
export class FreightShipperTemporaryStoreService {
  private store: Record<UUID, IFreightDetailedForShipper> = {};

  public get(id: UUID): IFreightDetailedForShipper {
    return this.store[id];
  }

  public has(id: UUID): boolean {
    return id in this.store;
  }

  public createOrUpdate(freight: IFreightDetailedForShipper): void {
    const exists = this.has(freight.id);
    this.store = exists ? this.update(freight.id, freight) : this.set(freight);
  }

  public delete(id: UUID): void {
    const { [id]: _, ...rest } = this.store;
    this.store = rest;
  }

  public clearAll(): void {
    this.store = {};
  }

  // -- private

  private set(freight: IFreightDetailedForShipper): Record<UUID, IFreightDetailedForShipper> {
    return {
      ...this.store,
      [freight.id]: freight,
    };
  }

  private update(id: UUID, freight: IFreightDetailedForShipper): Record<UUID, IFreightDetailedForShipper> {
    return {
      ...this.store,
      [id]: {
        ...this.store[id],
        ...freight,
      },
    };
  }

  // Auxiliary methods, not in use, for shallow and deep copies
  public getSnapshot(): Record<UUID, IFreightDetailedForShipper> {
    return { ...this.store };
  }

  public getSnapshotDeep(): Record<UUID, IFreightDetailedForShipper> {
    return structuredClone(this.store);
  }
}
